export default __webpack_public_path__ + "static/media/Poster_L2.17a356c1.svg";